import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMobile
    ? _c(
        "div",
        [
          _setup.lpuAddressListFiltered.length > 1
            ? _c("div", { staticClass: "text-subtitle-1 pl-2" }, [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _setup.t(
                        "Врач принимает в {countLpu} клиниках",
                        _setup.options
                      )
                    ) +
                    ":\n  "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _setup.lpuAddressListFiltered.length
            ? _c(
                VExpansionPanels,
                {
                  class:
                    _setup.lpuAddressListFiltered.length > 1
                      ? "custom-order-list"
                      : undefined,
                  attrs: { accordion: "", multiple: "", tile: "" },
                  model: {
                    value: _setup.expandedPanels,
                    callback: function ($$v) {
                      _setup.expandedPanels = $$v
                    },
                    expression: "expandedPanels",
                  },
                },
                _vm._l(
                  _setup.lpuAddressListFiltered,
                  function (lpuAddress, lpuAddressIndex) {
                    return _c(_setup.DoctorPageLpuListLpu, {
                      key: `${lpuAddress.id}-${lpuAddressIndex}-${_setup.filterType}`,
                      class:
                        _setup.lpuAddressListFiltered.length > 1
                          ? "custom-order-list__item"
                          : undefined,
                      attrs: {
                        "is-expanded":
                          _setup.expandedPanels.includes(lpuAddressIndex),
                        "lpu-address": lpuAddress,
                      },
                      on: {
                        "open-appointment-restrictions":
                          _setup.openAppointmentRestrictions,
                      },
                    })
                  }
                ),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.otherCountriesOfWork.length
            ? [
                _setup.lpuAddressListFiltered.length
                  ? _c(VDivider)
                  : _vm._e(),
                _vm._v(" "),
                _c(_setup.OtherCountriesOfDoctorWork),
              ]
            : _vm._e(),
          _vm._v(" "),
          _setup.lpuAddressListFiltered.length
            ? _c(_setup.AppointmentRestrictions, {
                ref: "appointmentRestrictionsRef",
              })
            : _vm._e(),
        ],
        2
      )
    : _c(
        VCard,
        { attrs: { flat: "" } },
        [
          _vm._l(
            _setup.lpuAddressListFiltered,
            function (lpuAddress, lpuAddressIndex) {
              return _c(_setup.DoctorPageLpuListLpu, {
                key: `${lpuAddress.id}-${lpuAddressIndex}-${_setup.filterType}`,
                attrs: { "lpu-address": lpuAddress },
                on: {
                  "open-appointment-restrictions":
                    _setup.openAppointmentRestrictions,
                },
              })
            }
          ),
          _vm._v(" "),
          _setup.otherCountriesOfWork.length
            ? _c(_setup.OtherCountriesOfDoctorWork, { staticClass: "mt-2" })
            : _vm._e(),
          _vm._v(" "),
          _setup.lpuAddressListFiltered.length
            ? _c(_setup.AppointmentRestrictions, {
                ref: "appointmentRestrictionsRef",
              })
            : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }